'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_button2.default.displayName = 'Button';

_button2.default.defaultProps = {
  ghost: false,
  htmlType: 'button',
  icon: '',
  loading: false,
  onClick: function onClick() {},
  prefixCls: 'ant-btn',
  shape: '',
  type: '',
  className: 'grab-ui'
};

_button2.default.propTypes = {
  ghost: _propTypes2.default.bool,
  htmlType: _propTypes2.default.oneOf(['submit', 'button', 'reset']),
  icon: _propTypes2.default.string,
  loading: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
  onClick: _propTypes2.default.func,
  prefixCls: _propTypes2.default.string,
  shape: _propTypes2.default.oneOf(['', 'circle']),
  size: _propTypes2.default.oneOf(['large', 'default', 'small']),
  type: _propTypes2.default.oneOf(['', 'default', 'primary', 'secondary', 'dashed', 'danger', 'ghost']),
  className: _propTypes2.default.string
};

exports.default = _button2.default;